import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import config from 'react-global-configuration';

import { DOMAIN_KVNL } from '../../config/constants';

import './style.scss';

const ThemeHeader = ({ theme, withTitle = false }) => {
  const { t } = useTranslation();

  const currentDomain = config.get('CURRENT_DOMAIN');

  if (!theme || currentDomain === DOMAIN_KVNL) {
    return null;
  }

  const classes = classnames('Theme__wrapper', {
    'Theme__wrapper--hideTitle': !withTitle,
  });

  const title = theme.getIn(['name', 0, 'value'], '');
  const icon = theme.getIn(['field_media_image', 0, 'source']);
  const alt = theme.getIn(['field_media_image', 0, 'entity', 'field_media_svg', 0, 'alt']);

  return (
    <div className={classes}>
      <div className="Theme__wrapper__icon">
        <Image src={icon} alt={alt} />
      </div>
      <div className="Theme__wrapper__text">
        {withTitle ? (
          <>
            <div className="Theme__wrapper__theme">{t('tags.theme')}</div>
            <h1>{title}</h1>
          </>
        ) : (
          <span>{title}</span>
        )}
      </div>
    </div>
  );
};

export default ThemeHeader;
